// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  TelemetryValueType,
} from "./types";

export default {
  endpointId: __t.u64(),
  jsonPath: __t.string(),
  targetStreamName: __t.string(),
  targetTwinId: __t.string(),
  get valueType() {
    return TelemetryValueType;
  },
  eventTimeJsonPath: __t.string(),
  eventTimeFormat: __t.string(),
  description: __t.string(),
  enabled: __t.bool(),
  targetComponent: __t.string(),
  detectedType: __t.string(),
};
